import {Component, OnInit, Input, Output, EventEmitter, Inject} from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

import {SocialService} from '../social.service';

@Component({
    selector: 'facebook-share-button',
    template: `
      <button class="button btn-block loginBtn --facebook" 
              (click)="sharing()" type="button">Share</button>
  `,
    styles: [`.button{font-family:Lato,"Lucida Grande","Lucida Sans Unicode",Tahoma,Sans-Serif;-webkit-appearance:none;display:inline-block;outline:0;border-radius:3px;border:3px solid transparent;cursor:pointer;text-overflow:ellipsis;text-decoration:none!important;font-weight:400!important}.loginBtn{box-sizing:border-box;position:relative;margin:.2em;padding:0 15px 0 46px;border:none;text-align:left;line-height:34px;white-space:nowrap;border-radius:3px;font-size:16px;color:#fff}.loginBtn:before{content:"";box-sizing:border-box;position:absolute;top:0;left:0;width:34px;height:100%}.loginBtn:focus{outline:0}.loginBtn:active{box-shadow:inset 0 0 0 32px rgba(0,0,0,.1)}.shareBtn{box-sizing:border-box;position:relative;margin:.2em;padding:0 15px 0 46px;border:none;text-align:left;line-height:34px;white-space:nowrap;border-radius:3px;font-size:16px;color:#fff}.shareBtn:before{content:"";box-sizing:border-box;position:absolute;top:0;left:0;width:34px;height:100%}.shareBtn:focus{outline:0}.shareBtn:active{box-shadow:inset 0 0 0 32px rgba(0,0,0,.1)}.--facebook{background-color:#4c69ba;background-image:linear-gradient(#4c69ba,#3b55a0);text-shadow:0 -1px 0 #354c8c}.--facebook:before{border-right:1px solid #364e92;background:url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_facebook.png) 6px 6px no-repeat}.--facebook:focus,.--facebook:hover{background-color:#5b7bd5;background-image:linear-gradient(#5b7bd5,#4864b1)}.--google{background:#dd4b39}.--google:before{border-right:1px solid #bb3f30;background:url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_google.png) 6px 6px no-repeat}.--google:focus,.--google:hover{background:#e74b37}.--linkedin{background:#007bb6}.--linkedin:before{border-right:1px solid #007bb6;background:url(https://content.linkedin.com/content/dam/developer/global/en_US/site/img/signin-button.png) -3px -3px no-repeat}.--linkedin:focus,.--linkedin:hover{background:linear-gradient(#007bb6,#4864b1)}`],
})
export class FacebookSharingButton implements OnInit {

    @Input() share: any = null;
    @Output() response = new EventEmitter<Boolean>();

    constructor(private socialAuthService: SocialService,
     @Inject(DOCUMENT) private document: any) { }

    ngOnInit() {

    }

    public sharing() {
        console.log(this.document.location.href);
        if(!this.share){
            this.share = {href:this.document.location.href}
        }else if(!this.share.href){
            this.share.href = this.document.location.href
        }
        this.socialAuthService.facebookSharing(this.share).then(()=>{
            this.response.emit(true);
        }).catch((err)=>{
            this.response.emit(false);
        });
    }

}
